import { render, staticRenderFns } from "./RetiredApproveMail.vue?vue&type=template&id=5b00a9c3&"
import script from "./RetiredApproveMail.vue?vue&type=script&lang=js&"
export * from "./RetiredApproveMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports